import ponticModel from "../model/ponticModel";
import stageDB from "../db/stageDB";

const getPonticModelListByStageNumber = (stageNumber) => {
  return ponticModel.getPonticModelListByStageNumber(stageNumber);
};

const getPonticModelListByStageNumberAndToothGumType = (stageNumber, toothGumType) => {
  const stageDO = stageDB.getStageDOFromStageNumberAndToothGumType(
    stageNumber,
    toothGumType
  );

  const stageDOList = stageDB.getStageDOListByToothGumType(toothGumType);

  const isUseActiveStageNumber = stageDOList.some((stageDO) => stageDO.activeStageNumber > stageNumber);

  const { activeStageNumber } = stageDO;

  return ponticModel.getPonticModelListByStageNumberAndToothGumType(isUseActiveStageNumber ? activeStageNumber : stageNumber, toothGumType);
};

export default {
  getPonticModelListByStageNumber,
  getPonticModelListByStageNumberAndToothGumType
};
